<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 11:59:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/searchorder/components/SearchTitleBar/index.vue
-->
<template>
  <div class="search_bar clearfix">
    <img
      src="@/assets/common/icon_back@2x.png"
      alt=""
      class="left search_go_back"
      @click.stop="back"
    />
    <div class="left bar_left">
      <div class="clearfix">
        <img
          src="@/assets/search/icon_search@2x.png"
          alt=""
          class="left search_icon"
        />
        <div class="left">
          <van-field
            v-model="value"
            placeholder="订单号/商品名称/收货人"
            @keypress="keypress"
            @blur="blurKey"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rightName: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    keyWords: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value: ""
    };
  },
  watch: {
    keyWords(newVal) {
      this.value = newVal || "";
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    keypress(eventcode) {
      this.$emit("keypress", this.value, eventcode);
    },
    blurKey() {
      this.$emit("blurKey", this.value);
    }
  }
};
</script>

<style lang="less" scoped>
.search_bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 1999;
  background: #fff;
  padding: 7px 12px;
  box-sizing: border-box;
  .search_go_back {
    width: 24px;
    cursor: pointer;
    margin: 5px 5px auto 0;
  }
  .bar_left {
    background: #f6f7f8;
    border-radius: 20px;
    height: 34px;
    .search_icon {
      width: 24px;
      padding: 5px 12px;
    }
    ::v-deep .van-cell {
      background: #f6f7f8;
      line-height: 34px;
      border-radius: 20px;
      width: 270px;
      display: block;
      padding: 0;
    }
  }
  .cancel_bar {
    padding: 0 12px 0 24px;
    line-height: 34px;
  }
}
</style>
